import React, { useEffect, useState, useRef } from 'react';
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { ArrowUpAZ, ArrowDownAZ, Pen, Trash2, History, QrCode, Images, X } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import QRCodeGenerator from '../../components/QRCodeGenerator.js';
import jsQR from "jsqr";
import Loader from '../../visualComponents/Loader.js';
import Tooltip from "../../components/Tooltip.js";

let selectTipologia = [];
let allIDs = [];
let selectAziende = [];
let isLoading = false;

const ImgPreview = ({ isVisible, setIsVisible, img }) => {

    if (!isVisible) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back"
            onClick={() => setIsVisible(false)}
        >
            <div className="p-4 rounded-lg" style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                <img
                    src={img}
                    alt="Preview"
                    className="max-w-full max-h-[80vh] mx-auto block rounded-md"
                />
            </div>
        </div>
    );
};

const PopUpFoto = ({ isVisible, setIsVisible, e }) => {
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [filter, setFilter] = useState("");
    const [isImgVisible, setIsImgVisible] = useState(false);
    const [img, setImg] = useState("");

    useEffect(() => {
        if (isVisible) {
            const getFoto = async () => {
                const r1 = await fetch('/getFotos', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDComponente: e["ID"]
                    }),
                });

                const rd1 = await r1.json();

                if (r1.status !== 200) {
                    alert(rd1.error);
                    console.error(rd1.error);
                    setIsVisible(false);
                }
                else {
                    console.log("FotoUtente: ", rd1);
                    setData(rd1);
                }
            };

            getFoto();
        }
    }, [isVisible]);

    useEffect(() => {
        setViewData(
            filter === ""
                ? data
                : data.filter((x) => {
                    const searchTerm = filter.toLowerCase();
                    return (
                        x["PathFoto"].split("/").pop().toLowerCase().includes(searchTerm) ||
                        x["Descrizione"].toLowerCase().includes(searchTerm) ||
                        x["Timestamp"].toLowerCase().includes(searchTerm) ||
                        x["NomeUtente"].toLowerCase().includes(searchTerm) ||
                        x["CognomeUtente"].toLowerCase().includes(searchTerm)
                    );
                })
        );
    }, [filter, data]);


    const closeModal = () => {
        setIsVisible(false);
    };

    const handleFotoClick = async (path) => {
        try {
            const r = await fetch('/getImage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PathFoto: path,
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                alert(rd.error);
                console.error(rd.error);
            }
            else {
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                console.log("URL immagine:", url);
                setImg(url);
                setIsImgVisible(true);
            }
        }
        catch (error) {
            console.error("Errore nel caricamento dell'immagine:", error);
            alert("Errore nel caricamento dell'immagine. Riprova più tardi.");
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Foto</h2>
                    <button className="text-red-500" onClick={closeModal}>
                        <X size={24} />
                    </button>
                </div>
                <div>
                    <input
                        type="text"
                        placeholder="Filtra foto..."
                        className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                    <div className="mt-2 overflow-y-auto max-h-[60vh]">
                        {viewData.length > 0 ? (
                            viewData.map((elem, index) => (
                                <>
                                    <div className="grid grid-cols-2 p-1 my-2 border-2 border-black dark:border-white hover:cursor-pointer rounded-md" onClick={() => handleFotoClick(elem["PathFoto"])} key={index}>
                                        <div className="self-center font-bold">{elem["PathFoto"].split("/").pop()}</div>
                                        <div className="self-center text-right">{elem["Timestamp"]}</div>
                                        <div className="self-center">{elem["Descrizione"]}</div>
                                        <div className="self-center text-right italic">{`${elem["CognomeUtente"]} ${elem["NomeUtente"]}`}</div>
                                    </div>
                                    <ImgPreview isVisible={isImgVisible} setIsVisible={setIsImgVisible} img={img} />
                                </>
                            ))
                        ) : (
                            <p className="text-center">Nessuna foto trovata.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const PopUpQR = ({ isVisible, setIsVisible, setQrCodeURL }) => {
    const [scanning, setScanning] = useState(false);
    const [qrCodeContent, setQRCodeContent] = useState(null);
    const canvasRef = useRef(null);

    const handleScanCode = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { ideal: 'environment' }
                }
            });
            const video = document.querySelector('video#scan');
            video.srcObject = stream;
            video.removeAttribute('hidden');
            setScanning(true);
            setQRCodeContent(null);

            requestAnimationFrame(detectQRCode);
        } catch (error) {
            // alert(error);
        }
    }

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasRef.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    setQRCodeContent(code.data);
                    const input = document.getElementById("qrCodeContent");
                    input.disabled = true;
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                // alert(error);
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const closeModal = () => {
        setIsVisible(false);
        setQRCodeContent(null);
        if (scanning) handleStopScan();
    };

    const handleStopScan = () => {
        const video = document.querySelector('video#scan');
        const stream = video.srcObject;
        const tracks = stream.getTracks();

        tracks.forEach(function (track) {
            track.stop();
        });

    };

    const handleConferma = async () => {
        try {
            isLoading = true;
            const response = await fetch("/checkCodiceQr", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceQr: qrCodeContent
                })
            });

            if (response.status === 500 || response.status === 401) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
            } else if (response.status === 200) {
                isLoading = false;
                setQrCodeURL(qrCodeContent);
                closeModal();
            }

        } catch (error) {
            alert("Errore, riprova più tardi");
            console.log(error);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold justify-self-center">QRCode</h2>
                </div>
                <div className="flex justify-center items-center mb-6 grid grid-cols-1">
                    <div className='flex justify-center '>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => {
                            setScanning(true);
                            handleScanCode();
                        }}>
                            Scansiona QRCode
                        </button>
                    </div>
                    <div className='flex justify-center mt-4'>
                        {
                            scanning ? (
                                <>
                                    <video muted autoPlay playsInline hidden width="30%" height="30%" id="scan" className="rounded"></video>
                                    <canvas
                                        ref={canvasRef}
                                        style={{ display: 'none' }}
                                        hidden
                                    />
                                </>
                            ) : null
                        }
                    </div>
                    <div className='flex justify-center mt-4'>
                        <p>oppure inserisci manualmente il codice corrispondente</p>
                    </div>
                    <div className="flex justify-center mt-4">
                        <input type="text" id="qrCodeContent" className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" value={qrCodeContent} onChange={(e) => setQRCodeContent(e.target.value)}>
                        </input>
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const PopUpComponente = ({ isVisible, setIsVisible, data, idAzienda }) => {
    const [codice, setCodice] = useState("");
    const [tipologia, setTipologia] = useState("");
    const [dataInstallazione, setDataInstallazione] = useState("");
    const [descrizione, setDescrizione] = useState("");
    const [isQrCodeVisible, setIsQrCodeVisible] = useState(false);
    const [id, setId] = useState(null);
    const [selectedIDAzienda, setSelectedIDAzienda] = useState(0);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (isVisible) {
            if (data) {
                setCodice(data["Codice"]);
                setDataInstallazione(data["DataInstallazione"].split('/')[2] + "-" + data["DataInstallazione"].split('/')[1] + "-" + data["DataInstallazione"].split('/')[0]);
                setDescrizione(data["Descrizione"]);
                setId(data["ID"]);

                const s1 = document.getElementById("tipologie");
                const v1 = data["CodiceTipologia"];
                s1.value = v1;
                setTipologia(v1);

                const s2 = document.getElementById("azienda");
                const v2 = idAzienda;
                s2.value = v2;
                setSelectedIDAzienda(v2);
            }
        }
    }, [isVisible, data]);

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };;

    const resetData = () => {
        setCodice(data ? data["Codice"] : "");
        setTipologia("");
        setDataInstallazione(data ? data["DataInstallazione"].split('/')[2] + "-" + data["DataInstallazione"].split('/')[1] + "-" + data["DataInstallazione"].split('/')[0] : "");
        setDescrizione(data ? data["Descrizione"] : "");
        setId(data ? data["ID"] : null);
        setSelectedIDAzienda(0);
    };

    const handleConferma = async () => {
        if (tipologia === "" || dataInstallazione === "" || id === null) {
            alert("Compilare tutti i campi");
            return;
        }

        if (data) { //modifica
            try {
                isLoading = true;
                const r1 = await fetch("/aggiornaComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: id,
                        Codice: codice,
                        CodiceTipologia: tipologia,
                        DataInstallazione: dataInstallazione,
                        Descrizione: descrizione,
                        IDAzienda: selectedIDAzienda
                    }),
                });
                if (r1.status === 500) {
                    const rd1 = await r1.json();
                    alert(rd1.error);
                    console.log(rd1.error);
                    resetData();
                    window.location.reload();
                } else {
                    isLoading = false;
                    window.location.reload();
                }

            } catch (error) {
                alert("Errore durante la modifica del componente, riprova più tardi");
                console.log(error);
                window.location.reload();
            }

        } else { //aggiunta
            try {
                isLoading = true;
                const r1 = await fetch("/addComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: id,
                        IDAzienda: idAzienda,
                        Codice: codice,
                        CodiceTipologia: tipologia,
                        DataInstallazione: dataInstallazione,
                        Descrizione: descrizione
                    }),
                });
                if (r1.status === 500) {
                    const rd1 = await r1.json();
                    alert(rd1.error);
                    console.log(rd1.error);
                    resetData();
                } else {
                    isLoading = false;
                    window.location.reload();
                }
            } catch (error) {
                alert("Errore durante l'aggiunta del componente, riprova più tardi");
                console.log(error);
                window.location.reload();
            }
        }
    };

    const handleImport = () => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".csv";
        fileInput.click();
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function (event) {
                const text = event.target.result;
                const rows = text.split("\n").map(row => row.split(",").map(cell => cell.replace(/"/g, "")));
                if (rows.length < 2) {
                    alert("File non valido");
                    return;
                }
                rows.shift();
                const data = rows[0][0].split(";");
                setCodice(data[0]);
                setTipologia(data[1]);
                setDataInstallazione(data[2]);
                setDescrizione(data[3]);
            };
            reader.onerror = function () {
                console.error("Errore durante la lettura del file CSV");
            };

            reader.readAsText(file);
        }
    };

    const handleExport = () => {
        if (tipologia === "" || dataInstallazione === "") {
            alert("Compilare tutti i campi");
            return;
        }

        const data = [
            ["Codice", "Tipologia", "Data Installazione", "Descrizione"],
            [codice, tipologia, dataInstallazione, descrizione]
        ];
        const filename = "Export_componente.csv";

        // Crea il contenuto del CSV
        const csvContent = data
            .map(row => row.map(cell => `"${cell}"`).join(";"))
            .join("\n"); // Unisci le righe con newline

        // Crea un blob con il contenuto CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Crea un link per scaricare il file
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", filename);

        // Aggiungi e clicca il link per forzare il download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleQrCode = async () => {
        if (id) {
            alert("Il QRCode è già stato collegato");
            return;
        }
        setIsQrCodeVisible(true);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-">
                    <h2 className="text-xl font-bold justify-self-center">{data ? "Modifica Componente" : "Aggiungi Componente"}</h2>
                </div>
                <div>
                    <div className='grid grid-cols-2 gap-4'>
                        <div className='flex justify-center'>
                            <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleImport}>
                                IMPORT
                            </button>
                        </div>
                        <div className='flex justify-center'>
                            <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleExport}>
                                EXPORT
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2 mt-4">
                        <p className="">Codice (opz): </p>
                        <input type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={codice}
                            onChange={(e) => setCodice(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 0)}
                            ref={el => inputRefs.current[0] = el}
                        ></input>
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Tipologia: </p>
                        <select id="tipologie"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            onChange={(e) => setTipologia(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={el => inputRefs.current[1] = el}
                        >
                            <option value=''>Seleziona una tipologia</option>
                            {
                                selectTipologia.map((d, index) => (
                                    <option key={index} value={d["Codice"]}>{d["Descrizione"]}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Data Installazione: </p>
                        <input
                            type="date"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={dataInstallazione}
                            onChange={(e) => setDataInstallazione(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 2)}
                            ref={el => inputRefs.current[2] = el}
                        ></input>
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Descrizione (opz): </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={descrizione}
                            onChange={(e) => setDescrizione(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 3)}
                            ref={el => inputRefs.current[3] = el}
                        ></input>
                    </div>
                    {
                        !data ? (
                            <div className="grid grid-cols-2 mx-5 mb-2">
                                <p className="">QRCode: </p>
                                <Tooltip content="QRCODE">
                                    <button className={`justify-self-center ${id ? "text-green-500" : "text-red-500"}`} onClick={handleQrCode}>
                                        <QrCode size={24} />
                                    </button>
                                </Tooltip>
                            </div>
                        ) : (
                            <div className="grid grid-cols-2 mx-5 mb-2">
                                <p className="">Cliente: </p>
                                <select id='azienda' className='rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' onChange={(e) => setSelectedIDAzienda(e.target.value)}>
                                    {
                                        selectAziende.map((d, index) => (
                                            <option key={index} value={d["ID"]}>{d["Nome"]}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        )
                    }
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
            <PopUpQR isVisible={isQrCodeVisible} setIsVisible={setIsQrCodeVisible} setQrCodeURL={setId} />
        </div>
    );
};

const TableRow = ({ data, check, onCheckChange, idAzienda }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isFotoVisible, setIsFotoVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare il componente?")) return;

        try {
            isLoading = true;
            const response = await fetch("/eliminaComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: data["ID"]
                })
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore durante l'eliminazione del componente, riprova più tardi");
            console.log(error);
            window.location.reload();
        }
    };

    return (
        <div className="grid grid-cols-9 gap-1 mt-2">
            <div className='flex items-center justify-end gap-4'>
                <input id={data[0]} type="checkbox" className='w-5 h-5 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' checked={check} onChange={onCheckChange} />
            </div>
            <div
                className={`col-span-7 bg-gray-300 dark:bg-gray-500 divide-x 
                divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 text-center break-words
                ${data["StatoAttuale"] === "In Scadenza" ? "border-2 border-orange-500" : (
                        data["StatoAttuale"] === "Scaduto" ? "border-2 border-red-600" : null
                    )
                    }`}
            >
                <div>{data.Codice === "" ? ("-----") : (data.Codice)}</div>
                <div>{data.DescrizioneTipologia}</div>
                <div>{data.DataInstallazione}</div>
                <div>{data.Descrizione === "" ? ("-----") : (data.Descrizione)}</div>
                <div>{data.StatoAttuale}</div>
                <div>{data.ProssimaManutenzione}</div>
                <div className='flex items-center justify-center'>{
                    <Tooltip content="Foto">
                        <button className="text-blue-500" onClick={() => setIsFotoVisible(true)}>
                            <Images size={24} />
                        </button>
                    </Tooltip>
                }</div>
            </div>
            <div className="flex items-center gap-1 ">
                {
                    data["Obsoleto"] === false ? (
                        <>
                            <Tooltip content="Modifica">
                                <button className="text-blue-500" onClick={() => setIsVisible(true)}>
                                    <Pen size={24} />
                                </button>
                            </Tooltip>
                            <Tooltip content="Elimina">
                                <button className="text-red-500" onClick={handleElimina}>
                                    <Trash2 size={24} />
                                </button>
                            </Tooltip>
                        </>
                    ) : null
                }

            </div>
            <PopUpComponente isVisible={isVisible} setIsVisible={setIsVisible} data={data} idAzienda={idAzienda} />
            <PopUpFoto isVisible={isFotoVisible} setIsVisible={setIsFotoVisible} e={data} />
        </div>
    );
};

const SezioneNascosta = ({ isVisible, idAzienda }) => {
    const navigate = useNavigate();
    const [indexTabella, setIndexTabella] = useState([
        { value: "Nome", dbCode: "Codice", ascending: true, filter: "text" },
        { value: "Tipologia", dbCode: "CodiceTipologia", ascending: true, filter: "text" },
        { value: "Data Installazione", dbCode: "DataInstallazione", ascending: true, filter: "text" },
        { value: "Descrizione", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Stato Attuale", dbCode: "StatoAttuale", ascending: true, filter: "text" },
        { value: "Prossima Manutenzione", dbCode: "ProssimaManutenzione", ascending: true, filter: "text" },
        { value: "Foto", ascending: true }
    ]);
    const [filters, setFilters] = useState({
        Codice: "",
        CodiceTipologia: "",
        DataInstallazione: "",
        Descrizione: "",
        StatoAttuale: "",
        ProssimaManutenzione: ""
    });
    const [viewData, setViewData] = useState([]);
    const [data, setData] = useState([]);
    const [archive, setArchive] = useState(false);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);

    useEffect(() => {
        // console.log(idAzienda);
        if (isVisible && idAzienda) onload();
    }, [isVisible, idAzienda]);

    useEffect(() => {
        setViewData(data.filter((d) => d.value["Obsoleto"] === archive));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData.filter((d) => d.value["Obsoleto"] === archive));
    }, [filters]);

    const onload = async () => {
        try {
            isLoading = true;
            const r1 = await fetch("/getComponenti", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    IDAzienda: idAzienda
                })
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                alert(rd1.error);
                console.log(rd1.error);
                navigate("/dashManager");
            } else {
                isLoading = false;
                setData(rd1.map((d) => ({ value: d, checked: false })));
                allIDs = rd1.map((d) => d["ID"]);
            }
        } catch (error) {
            alert("Errore nel caricamento dei dati, riprova più tardi");
            console.log(error);
            navigate("/dashManager");
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => d.value["Obsoleto"] === newArchive);
        setViewData(newData);
    };

    const handleAdd = () => {
        setIsPopUpVisible(true);
    };

    const handleStampa = async () => {
        const selectedElements = viewData.filter((d) => d.checked).map((d) => d.value["ID"]);
        if (selectedElements.length === 0) {
            alert("Seleziona almeno un componente");
            return;
        }
        const qrCodes = await generaQrCode(selectedElements);

        //open window to print all qrCodes
        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.write("<html><head><title>QRCode</title></head><body>");
        qrCodes.forEach((d) => {
            printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
        });
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        await new Promise((resolve) => setTimeout(resolve, 500));
        printWindow.print();
    };

    const generaQrCode = async (ids) => {
        let qrCodes = [];
        for (let i = 0; i < ids.length; i++) {
            qrCodes.push(await QRCodeGenerator.generateQRCode(ids[i]));
        }
        return qrCodes;
    };

    const handleCheckTotale = () => {
        let checkTotale = document.getElementById("tot").checked;
        let newData = [...data];
        newData.forEach((d) => d.checked = checkTotale);
        setData(newData);
    };

    const handleCheckChange = (id) => {
        let newData = [...data];
        newData.forEach((d, index) => {
            if (d["value"]["ID"] === id) d.checked = !d.checked;
        });
        setData(newData);
    };

    if (!isVisible) return null;

    return (
        <div>
            <div className='flex justify-center'>
                <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded" onClick={handleAdd}>
                    Aggiungi Componente
                </button>
            </div>
            <div id="tabella">
                <div className="grid grid-cols-9 gap-1 mt-4">
                    <div className='flex items-center justify-end gap-4'>
                        <input id="tot" type="checkbox" className='w-5 h-5' onChange={handleCheckTotale} />
                    </div>
                    <div className="col-span-7 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 font-bold text-center">
                        {
                            indexTabella.map((d, index) => (
                                d.value !== "Foto" ? (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        <Tooltip content="Ordina">
                                            <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                            </button>
                                        </Tooltip>
                                    </div>
                                ) : (
                                    <div key={index} className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                    </div>
                                )
                            ))
                        }
                    </div>
                    <div></div>
                </div>
                <div className="grid grid-cols-9 gap-4 mt-2">
                    <div className=''>
                    </div>
                    <div className="col-span-7 rounded-lg grid grid-cols-7 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                        {
                            indexTabella.map((d, index) => (
                                d.value !== "Foto" ? (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 8 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ) : (<div></div>)
                            ))
                        }
                    </div>
                    <div className='flex items-center'>
                        <Tooltip content="Archivio">
                            <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                <History size={24} />
                            </button>
                        </Tooltip>
                    </div>
                </div>
                {viewData.map((d, index) => (
                    <TableRow key={index} data={d.value} check={d.checked} onCheckChange={() => handleCheckChange(d.value["ID"])} idAzienda={idAzienda} />
                ))}
            </div>
            <div className='flex justify-center'>
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleStampa}>
                    Stampa QRCode
                </button>
            </div>
            <PopUpComponente isVisible={isPopUpVisible} setIsVisible={setIsPopUpVisible} idAzienda={idAzienda} />
        </div>
    );
};

const ComponentiManager = () => {
    const navigate = useNavigate();
    const [isSezioneNascostaVisible, setIsSezioneNascostaVisible] = useState(false);
    const [idAzienda, setIdAzienda] = useState(0);

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        //getInfoUtente
        try {
            // isLoading = true;

            await loadNav();

            //loadSelectAziende
            const r2 = await fetch('/getAziende', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                alert(rd2.error);
                console.error(rd2.error);
                navigate("/dashManager");
            } else {
                
                selectAziende = rd2.filter((d) => d["Obsoleta"] === false);

                //loadSelectTipologia
                const r3 = await fetch('/getTipologie', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"]
                    })
                });
                const rd3 = await r3.json();
                // console.log(rd3);
                if (r3.status === 500) {
                    alert(rd3.error);
                    console.error(rd3.error);
                    navigate("/dashManager");
                } else {
                    isLoading = false;
                    selectTipologia = rd3.filter((d) => d["Obsoleto"] === false);

                    //scelgo il preselezionato
                    if (document.cookie.indexOf("PreselectAzienda") !== -1) {
                        const preselect = document.cookie.split("PreselectAzienda=")[1].split(";")[0];
                        if (preselect !== '') {
                            setIdAzienda(preselect);
                            setIsSezioneNascostaVisible(true);
                        } else {
                            setIsSezioneNascostaVisible(false);
                        }
                    }
                }

            }
        } catch (error) {
            alert("Errore nel caricamento della pagina, riprova più tardi");
            console.log(error);
            navigate("/dashManager");
        }
    };

    const handleChange = (text) => {
        setIsSezioneNascostaVisible(false);

        console.log(text);
        setIdAzienda(text);

        if (text === '') {
            document.cookie = `PreselectAzienda=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            setIsSezioneNascostaVisible(false);
        }
        else {
            document.cookie = `PreselectAzienda=${text}; path=/;`;
            setIsSezioneNascostaVisible(true);
        }
    };

    return (
        <div className='min-h-screen bg-white dark:bg-gray-800'>
            <NavBar page="ANAGRAFICA ARTICOLI" />
            {isLoading && <Loader />}
            <div className='bg-white dark:bg-gray-800 text-black dark:text-white p-4'>
                <div className='flex justify-center mt-14 mb-4 gap-4'>
                    <p className='text-xl font-bold'>Cliente:</p>
                    <select id='aziendaGrossa' value={idAzienda} className='rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' onChange={(e) => { handleChange(e.target.value); }}>
                        <option value=''>Seleziona un cliente</option>
                        {
                            selectAziende.map((d, index) => (
                                <option key={index} value={d["ID"]}>{d["Nome"]}</option>
                            ))}
                    </select>
                </div>
                <SezioneNascosta isVisible={isSezioneNascostaVisible} idAzienda={idAzienda} />
            </div>
        </div>
    );
};

export default ComponentiManager;